import './popup'
import './scroll-fix'
import './form'
import './games'
import './copy'
import './blog'
import './publishing'

const menuBurger = document.querySelector('.menu-burger')
const headerMenu = document.querySelector('.header-menu')
const headerMenuList = document.querySelector('.header-menu__list')

menuBurger?.addEventListener('click', () => {
	menuBurger.classList.toggle('active')
	headerMenu.classList.toggle('header-menu_open')
	document.body.classList.toggle('scroll-lock')
})

headerMenu?.addEventListener('click', (e) => {
	if (e.target !== headerMenuList) {
		menuBurger.classList.remove('active')
		headerMenu.classList.remove('header-menu_open')
		document.body.classList.remove('scroll-lock')
	}
})

if (document.querySelector('.publish__cards')) {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active')
			}
		})
	})
	observer.observe(document.querySelector('.publish__cards'))
}

function addCssVhVariable() {
	let vh
	let browserBarsHeight = window.outerHeight - window.innerHeight
	if (window.innerHeight > window.innerWidth) {
		vh = window.innerHeight * 0.01
	} else {
		vh = (window.innerWidth - browserBarsHeight) * 0.01
	}
	document.documentElement.style.setProperty('--vh', `${vh}px`)
}

addCssVhVariable()

const videos = document.querySelectorAll('video')

document.addEventListener('visibilitychange', function () {
	if (!document.hidden) {
		videos.forEach((video) => {
			video.clientHeight > 0 && video.play()
		})
	}
})
;(function ($) {
	$('.accordion-heading').on('click', function () {
		if (!this.classList.contains('active')) {
			$('.accordion-content').slideUp(300)
			$('.accordion-heading').removeClass('active')
			$(this).next('.accordion-content').eq(0).slideDown(300)
			$(this).addClass('active')
		} else {
			$('.accordion-heading').removeClass('active')
			$(this).next('.accordion-content').eq(0).slideUp(300)
		}
	})
})(jQuery)

const downloadsContainer = document.querySelector('#count')

if (downloadsContainer) {
	let observer = new IntersectionObserver(
		(entry) => {
			if (entry[0].intersectionRatio === 1) {
				document.querySelectorAll('.downloads__numberColumn').forEach((item) => item.classList.add('animated'))
				document.querySelector('.downloads__numberAnimation').classList.add('animated')
				document.querySelector('.downloads__total').classList.add('animated')
			}
		},
		{
			threshold: 1
		}
	)

	observer.observe(downloadsContainer)
}
